<template>
  <div>
    <va-modal
      v-model="showModal"
      size="large"
      hide-default-actions
      noOutsideDismiss
      noEscDismiss
    >
      <template #header>
        <h2 class="va-h4">Импорт из CSV (Флорида)</h2>
      </template>

      <div class="mb-3">
        <div>
          <div>
            <input
              ref="csvInput"
              type="file"
              accept=".csv"
              @change="onFileSelected"
            />
          </div>

          <br />

          <div>
            <va-button
              color="primary"
              size="small"
              :disabled="!csvFile || loading"
              @click="runImport"
            >
              {{ loading ? "Импорт..." : "Импорт" }}
            </va-button>
          </div>
        </div>

        <div
          v-if="errorMessage"
          class="p-3 rounded mb-3"
          style="font-size: 0.9rem"
        >
          <p class="mb-0 font-weight-bold">Ошибка импорта</p>
          <p class="mb-0 mt-1">{{ errorMessage }}</p>
          <p v-if="errorCode" class="mb-0 mt-1 small opacity-90">
            Код: {{ errorCode }}
          </p>
        </div>

        <div v-if="result" class="p-3 rounded mb-3" style="font-size: 0.9rem">
          <p class="mb-2 font-weight-bold">{{ result.message }}</p>
          <template v-if="result.queued">
            <p class="mb-0 small opacity-90">
              Импорт выполняется в фоне. Обновите список товаров через 5–10 минут.
            </p>
          </template>
          <template v-else>
            <p class="mb-1">
              Категорий: <strong>{{ result.categories ?? 0 }}</strong>
            </p>
            <p class="mb-1">
              Товаров: <strong>{{ result.products ?? 0 }}</strong>
            </p>
          </template>
          <template v-if="result.images">
            <p class="mb-1 mt-2">Изображения:</p>
            <ul class="mb-0 pl-3">
              <li>
                попыток: <strong>{{ result.images.attempted ?? 0 }}</strong>
              </li>
              <li>
                загружено: <strong>{{ result.images.uploaded ?? 0 }}</strong>
              </li>
              <li>
                ошибок: <strong>{{ result.images.failed ?? 0 }}</strong>
              </li>
            </ul>
            <template v-if="result.images.failed_urls_sample?.length">
              <p class="mb-1 mt-2 small opacity-90">Примеры неудачных URL:</p>
              <ul
                class="mb-0 pl-3 small text-break"
                style="max-height: 100px; overflow-y: auto"
              >
                <li
                  v-for="(url, i) in result.images.failed_urls_sample"
                  :key="i"
                >
                  {{ url }}
                </li>
              </ul>
            </template>
          </template>
        </div>
      </div>

      <div class="d-flex justify-content-end mt-3">
        <va-button color="secondary" @click="close"> Закрыть </va-button>
      </div>
    </va-modal>
  </div>
</template>

<script>
import api from "@/api/axios";

export default {
  name: "ImportCSVModal",
  data() {
    return {
      showModal: false,
      csvFile: null,
      loading: false,
      result: null,
      errorMessage: null,
      errorCode: null,
    };
  },
  methods: {
    show() {
      this.result = null;
      this.errorMessage = null;
      this.errorCode = null;
      this.csvFile = null;
      this.showModal = true;
      this.$nextTick(() => {
        if (this.$refs.csvInput) this.$refs.csvInput.value = "";
      });
    },
    close() {
      this.showModal = false;
    },
    onFileSelected(event) {
      const file = event.target.files?.[0];
      this.csvFile = file || null;
      this.result = null;
      this.errorMessage = null;
      this.errorCode = null;
    },
    async runImport() {
      if (!this.csvFile) return;
      this.loading = true;
      this.result = null;
      this.errorMessage = null;
      this.errorCode = null;
      try {
        const formData = new FormData();
        formData.append("florida_csv_file", this.csvFile);
        const res = await api.post("/admin/products/florida-import", formData);
        const data = res.data || {};
        this.result = {
          message: data.message || "Импорт завершён.",
          categories: data.categories ?? 0,
          products: data.products ?? 0,
          images: data.images ?? null,
        };
        this.csvFile = null;
        if (this.$refs.csvInput) this.$refs.csvInput.value = "";
        this.$emit("imported");
      } catch (err) {
        const data = err.response?.data;
        const msg =
          (data && typeof data.message === "string" ? data.message : null) ||
          err.message ||
          "Ошибка импорта";
        this.errorMessage = msg;
        this.errorCode = data?.code ?? null;
        this.$emit("error", msg);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
